var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBybitSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 1.44
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 32.0958,
    y1: 17.0565,
    x2: 32.0958,
    y2: 26.3145
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 34.3665,
    y1: 19.371,
    x2: 40.5,
    y2: 19.371
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 37.4333,
    y1: 28.629,
    x2: 37.4333,
    y2: 19.371
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "21.29 19.371 18.224 24 15.157 19.371"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 18.2237,
    y1: 28.629,
    x2: 18.2237,
    y2: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.3189,24a2.3145,2.3145,0,1,1,0,4.629H7.5V19.371h3.8189a2.3145,2.3145,0,1,1,0,4.629Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.3189,
    y1: 24,
    x2: 7.5,
    y2: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.38,24a2.3145,2.3145,0,1,1,0,4.629H23.561V19.371H27.38a2.3145,2.3145,0,1,1,0,4.629Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 27.3799,
    y1: 24,
    x2: 23.561,
    y2: 24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 24,
    cy: 24,
    r: 21.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 32.0958,
    y1: 17.0565,
    x2: 32.0958,
    y2: 26.3145
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 34.3665,
    y1: 19.371,
    x2: 40.5,
    y2: 19.371
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 37.4333,
    y1: 28.629,
    x2: 37.4333,
    y2: 19.371
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "21.29 19.371 18.224 24 15.157 19.371"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 18.2237,
    y1: 28.629,
    x2: 18.2237,
    y2: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.3189,24a2.3145,2.3145,0,1,1,0,4.629H7.5V19.371h3.8189a2.3145,2.3145,0,1,1,0,4.629Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.3189,
    y1: 24,
    x2: 7.5,
    y2: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.38,24a2.3145,2.3145,0,1,1,0,4.629H23.561V19.371H27.38a2.3145,2.3145,0,1,1,0,4.629Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 27.3799,
    y1: 24,
    x2: 23.561,
    y2: 24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 24,
    cy: 24,
    r: 21.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBybitSvgrepoCom);
export default __webpack_public_path__ + "static/media/bybit-svgrepo-com.4d633c8c0f99c94f05e8946a459c12cf.svg";
export { ForwardRef as ReactComponent };